import stSettleEasyButton from './settleEasyButton.component';

export default angular
  .module('st.Integrations.SettleEasy', ['st.Core', 'angular-cache'])
  .component('stSettleEasyButton', stSettleEasyButton)
  .service('settleEasyService', ($http, dataService, SETTLE_EASY) => ({
    refer: (params) =>
      dataService.apiRequest(
        null,
        null,
        true,
        null,
        $http.post,
        SETTLE_EASY.API.REFER,
        { params },
        null,
        true
      )
  }))
  .constant('SETTLE_EASY', {
    API: {
      REFER: '/api/v1/integrations/settle-easy/refer'
    }
  });
